import mixpanel from 'mixpanel-browser';
import { registerFormStepsEnum } from 'modules/general/enums';

export const initMixpanel = () => {
  let distinctId;
  mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY, {
    loaded(mixpanelInstance) {
      distinctId = mixpanelInstance.get_distinct_id();

      mixpanelInstance.register({
        distinct_id: distinctId,
      });

      mixpanelInstance.identify(distinctId);
    },
  });
};

export const registerFormMixpanelHandler = {
  fireRegisterFormMixpanelEvent(currentStep, mixpanelObj, data) {
    const dataObj = {
      'Industry Selected':
        (data.businessIndustry === 'Other' && `Other - ${data.otherbusinessIndustry}`) ||
        data.businessIndustry,
      'Company Name': data.companyName,
      'Company City': data.companyCityName,
      'Company Area': data.companyAreaName,
      'Company Location Address': data.companyLocation,
      'Floor Apartement': data.companyApartment,
      'Company email': data.companyEmail,
      'Website URL': data.companyWebsite,
      'Company Mobile Number': data.companyMobileNumber,
      'Phone Number': data.companyPhoneNumber,
      Fax: data.companyFax,
      'Position Selected':
        (data.userPosition === 'Other' && `Other - ${data.otheruserPosition}`) || data.userPosition,
      'Creator Name': data.accountName,
      'Creator Email': data.accountEmail,
      'Creator Mobile Number': data.accountMobileNumber,
    };

    switch (currentStep) {
      case registerFormStepsEnum.businessIndustry:
        mixpanelObj.track('Business Industry', {
          'Industry Selected':
            (data.businessIndustry === 'Other' && `Other - ${data.otherbusinessIndustry}`) ||
            data.businessIndustry,
          Source: 'Select Industry View',
        });
        break;

      case registerFormStepsEnum.companyInformation:
        mixpanelObj.track('Company Information', {
          'Company Name': data.companyName,
          City: data.companyCityName,
          Area: data.companyAreaName,
          'Location Address': data.companyLocation,
          'Floor Apartement': data.companyApartment,
          'Company email': data.companyEmail,
          'Website URL': data.companyWebsite,
          'Company Mobile Number': data.companyMobileNumber,
          'Phone Number': data.companyPhoneNumber,
          Fax: data.companyFax,
        });
        break;

      case registerFormStepsEnum.userPosition:
        mixpanelObj.track('Position Selected', {
          'Position Selected':
            (data.userPosition === 'Other' && `Other - ${data.otheruserPosition}`) ||
            data.userPosition,
          'Company Name': data.companyName,
          'Company Mobile Number': data.companyMobileNumber,
          'Company email': data.companyEmail,
        });
        break;

      case registerFormStepsEnum.accountInformation:
        mixpanelObj.track('Account Creation', {
          name: data.accountName,
          Email: data.accountEmail,
          'Mobile Number': data.accountMobileNumber,
          'Company Name': data.companyName,
          'Company Mobile Number': data.companyMobileNumber,
          'Company email': data.companyEmail,
        });
        break;

      case registerFormStepsEnum.confirmation:
        mixpanelObj.track('Thank you', dataObj);
        mixpanel.people.set(dataObj);
        break;

      default:
    }
  },
};
